import { SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';

export const useTireImages = () => {
  const { images } = useExteriorSectionData('tires');

  const typedImages = images.reduce((acc, curr) => {
    if (!curr.type || curr.type.includes('_plate')) return acc;
    return { ...acc, [curr.type]: curr };
  }, {} as Record<string, SectionImage>);

  const orderedImages = [
    typedImages['tires.driver_front_tire'],
    typedImages['tires.driver_front_wheel'],
    typedImages['tires.driver_rear_tire'],
    typedImages['tires.driver_rear_wheel'],
    typedImages['tires.passenger_front_tire'],
    typedImages['tires.passenger_front_wheel'],
    typedImages['tires.passenger_rear_tire'],
    typedImages['tires.passenger_rear_wheel'],
    ...images.filter(img => !img.type)
  ].filter(Boolean);

  return orderedImages;
};
